<div class="d-flex justify-content-end align-items-center">
  @for (action of actions; track action.label; let i = $index) {
    <div style="width: 30px; display: flex; justify-content: center">
      @if ((isDisabled && isDisabled(row)) || (action.condition && !action.condition(row))) {
        <div style="vertical-align: middle">
          <i
            class="fa-solid text-muted {{ getIcon(action, row) }} {{
              action.classes ? action?.classes(row) : ''
            }}"
            id="Disabled"
          ></i>
        </div>
      } @else {
        <a
          (click)="action.action(row, index)"
          [routerLink]="action.routerLink ? getRouterLink(action, row) : null"
          [queryParams]="getQueryParams(action, row)"
          style="vertical-align: middle"
          id="notDisabled"
          data-bs-toggle="tooltip"
          title="{{ getLabel(action, row) }}"
          container="body"
        >
          <i
            class="{{ getIcon(action, row).includes('fa-kit') ? '' : 'fa-solid' }} {{
              getIcon(action, row)
            }} {{ action.classes ? action?.classes(row) : '' }}"
          ></i>
        </a>
      }
    </div>
  }
</div>
